import { render } from "./barcode-information.vue?vue&type=template&id=e3bd5e7c&scoped=true"
import script from "./barcode-information.vue?vue&type=script&lang=js"
export * from "./barcode-information.vue?vue&type=script&lang=js"

import "./barcode-information.vue?vue&type=style&index=0&id=e3bd5e7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3bd5e7c"]])

export default __exports__